/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invitesubbonusmessage3Inputs */



/**
* | output |
* | --- |
* | "Two friends joined Luni! Enjoy 7 days of 'Monster' subscription on us." |
*
* @param {Invitesubbonusmessage3Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const invitesubbonusmessage3 = /** @type {((inputs?: Invitesubbonusmessage3Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invitesubbonusmessage3Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Two friends joined Luni! Enjoy 7 days of 'Monster' subscription on us.")
	if (locale === "es") return /** @type {LocalizedString} */ ("¡Dos amigos se unieron a Luni! Disfruta de 7 días de suscripción «Monster» de nuestra parte.")
	return /** @type {LocalizedString} */ ("Двое твоих друзей приняли приглашение. Тебе подключена подписка «Монстр» на 7 дней.")
});
export { invitesubbonusmessage3 as "inviteSubBonusMessage" }